import React, { useRef, useState } from 'react';
import moment from 'moment';
import { useEffect } from 'react';
import { GetStationReport } from './function';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectPrefix,
  selectWidth,
  selectreportFromDate,
  selectreportToDate,
  setreportsFromDate,
  setreportsTodate,
} from '../utility/Redux/profile';
import { selectToken } from '../utility/Redux/security';
import { StationReportColumns, StationReportColumnsQntyWise } from './columns';
import { FormatNumber2 } from '../utility/component/tools';
import GeniusReportsDate from '../utility/component/reportDate';
import { selectReportType } from '../utility/Redux/refresh';
import ReactToPrint from 'react-to-print';
import GeniusTableForReports from '../utility/component/geniusComponents/geniusTableforReports';
import IsLocalData from '../utility/functions/ceckLocalData';
import ReportDataTable from '../utility/component/datagrid/ReportDataTable';

const StationBalanceReport = () => {
  // Date Properties
  const fromDate = useSelector(selectreportFromDate);
  const [fromDateFocus, setFromDateFocus] = useState(false);
  const toDate = useSelector(selectreportToDate);
  const [toDateFocus, setToDateFocus] = useState(false);
  const printRef = useRef();
  const [showType, setShowType] = useState(1);

  // Datagrid Properties
  const [list, setList] = useState([]);

  // redux Propertioes
  const prefix = useSelector(selectPrefix);
  const dispatch = useDispatch();
  const token = useSelector(selectToken);
  const windowWidth = useSelector(selectWidth);

  // useEffect;
  const okButton = () => {
    GetStationReport(prefix, dispatch, token, setList, fromDate, toDate);
  };

  const columns =
    showType === 1
      ? StationReportColumns(windowWidth)
      : StationReportColumnsQntyWise(windowWidth);

  const tableColumns = columns.map((column) => {
    const wideAmountFields = ['IAMOUNT', 'RAMOUNT', 'SAMOUNT'];
    const amountFields = [
      'COLLECTION',
      'DEBIT',
      'DUE',
      'EXPENSE',
      'LESS',
      'CASH',
      'BALANCE',
    ];

    if (wideAmountFields.includes(column.field)) {
      return { ...column, width: Math.max(Number(column.width) || 0, 150) };
    }

    if (amountFields.includes(column.field)) {
      return { ...column, width: Math.max(Number(column.width) || 0, 120) };
    }

    return column;
  });

  const totalCash = list.reduce(
    (total, row) => Number(total) + Number(row.CASH),
    0
  );
  const totalCollection = list.reduce(
    (total, row) => Number(total) + Number(row.COLLECTION),
    0
  );
  const totalDebit = list.reduce(
    (total, row) => Number(total) + Number(row.DEBIT),
    0
  );

  const totalBalcence = list.reduce(
    (total, row) => Number(total) + Number(row.BALANCE),
    0
  );

  const totalDUE = list.reduce(
    (total, row) => Number(total) + Number(row.DEBIT - row.COLLECTION),
    0
  );

  const totalExpense = list.reduce(
    (total, row) => Number(total) + Number(row.EXPENSE),
    0
  );

  const totalLess = list.reduce(
    (total, row) => Number(total) + Number(row.LESS),
    0
  );

  const totalIqnty = list.reduce(
    (total, row) => Number(total) + Number(row.IQNTY),
    0
  );

  const totalRQnty = list.reduce(
    (total, row) => Number(total) + Number(row.RQNTY),
    0
  );

  const totalIAmount = list.reduce(
    (total, row) => Number(total) + Number(row.IAMOUNT),
    0
  );

  const totalRAmount = list.reduce(
    (total, row) => Number(total) + Number(row.RAMOUNT),
    0
  );
  const totalSqnty = list.reduce(
    (total, row) => Number(total) + Number(row.SQNTY),
    0
  );
  const totalSAmount = list.reduce(
    (total, row) => Number(total) + Number(row.SAMOUNT),
    0
  );

  const footerValue = (column) => {
    if (column.field === 'SNAME') return 'TOTAL';
    if (column.field === 'CASH' && totalCash > 0) return FormatNumber2(totalCash);
    if (column.field === 'COLLECTION' && totalCollection > 0) return FormatNumber2(totalCollection);
    if (column.field === 'DEBIT' && totalDebit > 0) return FormatNumber2(totalDebit);
    if (column.field === 'DUE' && totalDUE) return FormatNumber2(totalDUE);
    if (column.field === 'EXPENSE' && totalExpense > 0) return FormatNumber2(totalExpense);
    if (column.field === 'LESS' && totalLess > 0) return FormatNumber2(totalLess);
    if (column.field === 'IQNTY' && totalIqnty > 0) return FormatNumber2(totalIqnty);
    if (column.field === 'RQNTY' && totalRQnty > 0) return FormatNumber2(totalRQnty);
    if (column.field === 'RAMOUNT' && totalRAmount > 0) return FormatNumber2(totalRAmount);
    if (column.field === 'IAMOUNT' && totalIAmount > 0) return FormatNumber2(totalIAmount);
    if (column.field === 'SQNTY' && totalSqnty > 0) return FormatNumber2(totalSqnty);
    if (column.field === 'SAMOUNT' && totalSAmount > 0) return FormatNumber2(totalSAmount);
    if (column.field === 'BALANCE' && totalBalcence > 0) return FormatNumber2(totalBalcence);
    return '';
  };

  useEffect(() => {
    const elseFunc = () => {};
    const callback = (details, data) => {
      setList(data);
      console.log(details);
      dispatch(
        setreportsFromDate(moment(details[0].FDATE).format('YYYY-MM-DD'))
      );
      dispatch(setreportsTodate(moment(details[0].TDATE).format('YYYY-MM-DD')));
    };
    IsLocalData('All_Stations_Balance_Report', callback, elseFunc);
  }, []);
  return (
    <div className="h-full w-full p-1 text-sm">
      <div
        style={{
          border: '1px solid #b5b3b3',
        }}
        className="p-1 py-[11px] rounded-sm flex items-center "
      >
        <div className="px-1 pl-3">From </div>

        <GeniusReportsDate
          date={fromDate}
          onChange={(d) => {
            dispatch(setreportsFromDate(moment(d).format('YYYY-MM-DD')));
            setFromDateFocus(false);
          }}
          dateFocus={fromDateFocus}
          SetDateFocus={setFromDateFocus}
        />
        <div className="mx-4">To</div>
        <GeniusReportsDate
          date={toDate}
          onChange={(d) => {
            dispatch(setreportsTodate(moment(d).format('YYYY-MM-DD')));
            setToDateFocus(false);
          }}
          dateFocus={toDateFocus}
          SetDateFocus={setToDateFocus}
        />
        <div className="flex">
          <button
            onClick={okButton}
            className="flex items-center rounded-sm ml-2"
            style={{
              backgroundColor: '#c1c1c1',
              paddingLeft: 30,
              paddingRight: 30,
              paddingTop: 4,
              paddingBottom: 4,
              color: 'black',
            }}
          >
            <div className="flex items-center text-sm">Ok</div>
          </button>

          <ReactToPrint
      trigger={() => (
        <button
          style={{
            width: 'auto',
            borderRadius: '7px',
            height: 'auto',
            padding: '4px 30px',
            backgroundColor: '#bad4f9',
            color: 'black',
            marginLeft: 7,
          }}
        >
          <div className="text-sm">Print</div>
        </button>
      )}
      content={() => printRef.current}
    />

          <button
            onClick={() => {
              setShowType((o) => (o === 1 ? 2 : 1));
            }}
            className="flex items-center rounded-sm ml-2 bg-orange"
            style={{
              paddingLeft: 30,
              paddingRight: 30,
              paddingTop: 4,
              paddingBottom: 4,
              color: 'black',
            }}
          >
            <div className="flex items-center text-sm">
              {' '}
              {showType === 1 ? 'Show Qnty Wise' : 'Full Report'}
            </div>
          </button>
        </div>
      </div>
   
      <div
        style={{
          height: `calc(100% - 120px)`,
        }}
        className="mt-2 w-full"
      >
        <ReportDataTable
          columns={tableColumns}
          rows={list}
          getRowKey={(row) => row.SID}
          footerValue={footerValue}
          emptyTitle="No records found"
          emptyDescription="Run the report to view station balances."
          maxHeight="100%"
        />
      </div>

      <div
        ref={printRef}
        style={{ width: '100%', display: 'block', visibility: 'hidden' }}
      >
        <GeniusTableForReports
          date={fromDate}
          date1={toDate}
          columns={columns}
          data={list}
          Fotter ={
            <div className="mt-6">
              {/* Totals Table */}
              <div className="grid grid-cols-2 gap-3 max-w-md ml-auto">
                {columns.map((col, i) => {
                  let value = '';
                  let header;
                  switch (col.field) {
                    case 'CASH':
                      value = totalCash > 0 ? FormatNumber2(totalCash) : '';
                      header = "Cash";
                      break;
                    case 'COLLECTION':
                      value = totalCollection > 0 ? FormatNumber2(totalCollection) : '';
                      header = "Collection";
                      break;
                    case 'DEBIT':
                      value = totalDebit > 0 ? FormatNumber2(totalDebit) : '';
                      header = "Debit";
                      break;
                    case 'DUE':
                      value = totalDUE > 0 ? FormatNumber2(totalDUE) : '';
                      header = "Due";
                      break;
                    case 'EXPENSE':
                      value = totalExpense > 0 ? FormatNumber2(totalExpense) : '';
                      header = "Expense";
                      break;
                    case 'LESS':
                      value = totalLess > 0 ? FormatNumber2(totalLess) : '';
                      header = "Less";
                      break;
                    case 'IQNTY':
                      value = totalIqnty > 0 ? FormatNumber2(totalIqnty) : '';
                      header = "Issue Qnty";
                      break;
                    case 'RQNTY':
                      value = totalRQnty > 0 ? FormatNumber2(totalRQnty) : '';
                      header = "Return Qnty";
                      break;
                    case 'RAMOUNT':
                      value = totalRAmount > 0 ? FormatNumber2(totalRAmount) : '';
                      header = "Return Amt.";
                      break;
                    case 'IAMOUNT':
                      value = totalIAmount > 0 ? FormatNumber2(totalIAmount) : '';
                      header = "Issue Amt.";
                      break;
                   
                    case 'SQNTY':
                      value = totalSqnty > 0 ? FormatNumber2(totalSqnty) : '';
                      header = "Sale Qnty";
                      break;
                    case 'SAMOUNT':
                      value = totalSAmount > 0 ? FormatNumber2(totalSAmount) : '';
                      header = "Sale Amt.";
                      break;
                    case 'BALANCE':
                      value = totalBalcence > 0 ? FormatNumber2(totalBalcence) : '';
                      header = "Balance";
                      break;
                    default:
                      value = '';
                  }
          
                  if (!value) return null;
          
                  return (
                    <div key={i} className="flex justify-between items-center border-b border-gray-100 py-1">
                      <span className="font-medium text-gray-700">{header} :</span>
                      <span className="font-semibold text-right text-gray-900 w-32">{value}</span>
                    </div>
                  );
                })}
              </div>
          
              {/* Highlighted Balance Row */}
              <div className="flex justify-between mt-6 pt-3 border-t-2 border-gray-300 font-bold text-gray-900 max-w-md ml-auto text-lg">
                <span>Balance</span>
                <span className="text-right w-32">{FormatNumber2(totalBalcence || 0)}</span>
              </div>
            </div>
          }
          
          
          title={'All Station Balance Report'}
        />
      </div>
    
    </div>
  );
};

export default StationBalanceReport;
